import { render, staticRenderFns } from "./ModalEliminazione.vue?vue&type=template&id=774f212d"
import script from "./ModalEliminazione.vue?vue&type=script&lang=js"
export * from "./ModalEliminazione.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports